import React from "react";

// Imports
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "../styles/Icons.css";

function Icons() {
  return (
    <div className="Icons">
      <a
        href="https://www.facebook.com/JowellsBarbershop"
        className="icon i-facebook"
      >
        <FacebookIcon />
      </a>
      <a
        href="https://www.instagram.com/jowellsbarbershop/"
        className="icon i-instagram"
      >
        <InstagramIcon />
      </a>
      <a href="https://wa.me/51931580247" className="icon i-whatsapp">
        <WhatsAppIcon />
      </a>
    </div>
  );
}

export default Icons;
